import * as actionTypes from "./actionTypes";
import * as types from "./types";


// POST Override
const initialStateOverride: types.IPostOverrideRequestState = {
    pending: false,
    override: null,
    error: null
};

export const PostOverrideRequestReducer = (state = initialStateOverride, action: types.PostOverrideActions) => {

    switch (action.type) {
        case actionTypes.POST_OVERRIDEREQUEST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.POST_OVERRIDEREQUEST_SUCCESS:
            return {
                ...state,
                pending: false,
                override: action.payload.override,
                error: null,
            };
        case actionTypes.POST_OVERRIDEREQUEST_FAILURE:
            return {
                ...state,
                pending: false,
                override: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }

};


// PATCH Override Request

const initialStatePatchOverrideRequest: types.IPatchOverrideRequestState = {
    pending: false,
    success: null,
    error: null,
};

export const PatchOverrideRequestReducer = (state = initialStatePatchOverrideRequest, action: types.PatchOverrideRequestActions) => {
    switch (action.type) {

        case actionTypes.PATCH_OVERRIDEREQUEST_REQUEST:
            return {
                ...state,
                success: null,
                pending: true,
            };
        case actionTypes.PATCH_OVERRIDEREQUEST_SUCCESS:
            return {
                ...state,
                pending: false,
                success: action.success,
                error: null,
            };
        case actionTypes.PATCH_OVERRIDEREQUEST_FAILURE:
            return {
                ...state,
                pending: false,
                success: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }

};

// GET Override Request 

const initOverrideRequestState: types.OverrideRequestState = {
    pending: false,
    override: null,
    error: null,
};

export const OverrideRequestDetailsReducer = (state = initOverrideRequestState, action: types.FetchOverrideRequestActions) => {
    switch (action.type) {
        case actionTypes.FETCH_OVERRIDEREQUEST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_OVERRIDEREQUEST_SUCCESS:
            return {
                ...state,
                pending: false,
                override: action.payload.override,
                error: null,
            };
        case actionTypes.FETCH_OVERRIDEREQUEST_FAILURE:
            return {
                ...state,
                pending: false,
                override: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};


// GET Override Requests

const initOverrideRequestsListState: types.OverrideRequestListState = {
    pending: false,
    overrideRequests: {} as types.IOverrideRequestList,
    error: null,
  };
  
  export const OverrideRequestsListReducer = (state = initOverrideRequestsListState, action: types.OverrideRequestsActions) => {
    switch (action.type) {
        case actionTypes.FETCH_OVERRIDEREQUEST_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_OVERRIDEREQUEST_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                overrideRequests: action.payload.overrideRequests,
                error: null,
            };
        case actionTypes.FETCH_OVERRIDEREQUEST_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                overrideRequests: {} as types.IOverrideRequestList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
  };